<template>
    <transition name="fade">
        <div
            v-show="time <= 10"
            ref="modal"
            class="modal-background fixed w-full h-full inset-x-0 inset-y-0 flex items-center justify-center z-50"
        >
            <div
                class="bg-white max-w-2xl w-full p-12 text-center rounded-xl shadow-lg"
            >
                <h3
                    class="font-normal text-2xl lg:text-4xl mb-6 lg:mb-8 leading-none"
                >
                    Are you still here?
                </h3>
                <div class="font-semibold text-3xl text-grey-dark mb-6 lg:mb-8">
                    {{ time }}
                </div>
                <button
                    ref="resetButton"
                    class="inline-block bg-orange hover:bg-orange-dark text-white text-lg font-semibold rounded-xl leading-none py-3 px-8 no-underline focus:outline-none focus:ring-2 focus:ring-teal-light"
                    @click="resetTimer"
                >
                    Yes
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            time: 60,
            timer: null,
        };
    },
    watch: {
        time(val) {
            if (val === 10) {
                document.body.classList.add('overflow-hidden');
            }
        },
    },
    mounted() {
        document.body.addEventListener('scroll', this.resetTimer);
        document.body.addEventListener('click', this.resetTimer);
        document.body.addEventListener('keydown', this.resetTimer);

        this.startTimer();
    },
    methods: {
        startTimer() {
            document.body.classList.remove('overflow-hidden');

            this.timer = setInterval(() => {
                if (this.time) {
                    return this.time--;
                }
                axios
                    .post('/logout')
                    .then(() => this.redirect())
                    .catch(() => {});
            }, 1000);
        },
        resetTimer(event = null) {
            if (this.modalContainsClickTarget(event)) {
                return;
            }

            this.time = 60;
            clearInterval(this.timer);

            this.startTimer();
        },
        redirect() {
            window.location.assign('/');
        },
        modalContainsClickTarget(event = null) {
            if (!event) {
                return true;
            }
            if (event.target === this.$refs.resetButton) {
                return false; // Allow the reset button
            }
            if (event.target === this.$refs.modal) {
                return true; // Clicked the modal
            }
            if (this.$refs.modal.contains(event.target)) {
                return true; // Clicked something inside the modal
            }
            return false;
        },
    },
};
</script>

<style scoped>
.modal-background {
    background: rgba(0, 0, 0, 0.65);
}
</style>
